import { AboutUs } from '~/components/AboutUs/AboutUs'

export default function AboutUsPage() {
  return <AboutUs />
}